module.exports = __webpack_public_path__ + "img/在线设备@2x.de944eba.png";